<template>
  <div>
    <ts-loading-banner :loading="student_search">
      <form>
        <fieldset>
          <legend>{{ $t('studentEnrollment.enroll') }}</legend>
          <div class="overflow-auto" id="enroll">
            <panel :title="$t('studentEnrollment.studentList')">
              <div id="student-table-container">
                <table
                  class="table table-hover ui-table ts-table"
                  id="student-table"
                >
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.cardNumber') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.studentName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.sex') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.studyTime') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.major') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.level') }}
                      </th>
                      <th class="ts-whitespace-no-wrap text-cneter">
                        {{ $t('studentEnrollment.batch') }}
                      </th>
                    </tr>
                    <tr>
                      <th colspan="7">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('studentEnrollment.searchStudent')"
                          v-model="student_search_value"
                          :disabled="model.class_id == ''"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(student, index) in studentLists"
                      :key="index"
                      @dblclick="selectStudent(student)"
                    >
                      <td class="ts-whitespace-no-wrap">
                        {{ student.card_number ? student.card_number : null }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.full_name_en }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.gender }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.study_time ? student.study_time : '' }}
                        {{ student ? student.session : '' }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.acps_name_foreign }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.level_name_foreign }}
                      </td>
                      <td class="ts-whitespace-no-wrap text-center">
                        {{ student.promotion }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </panel>
            <panel :title="$t('studentEnrollment.enrollmentList')">
              <div class="overflow-auto">
                <table class="table table-hover ui-table ts-table mt-2">
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.cardNumber') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.studentName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.sex') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width: 7%">
                        {{ $t('studentEnrollment.studyTime') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width: 7%">
                        {{ $t('studentEnrollment.major') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width: 7%">
                        {{ $t('studentEnrollment.level') }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width: 7%"
                      >
                        {{ $t('studentEnrollment.batch') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width: 3%">
                        {{ $t('actions') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(list, index) in model.student_id_list"
                      :key="index"
                    >
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).card_number
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).full_name_en
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).gender
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).study_time
                        }}
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).session
                        }}
                      </td>

                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).acps_name_foreign
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).level_name_foreign
                        }}
                      </td>
                      <td class="ts-whitespace-no-wrap text-center">
                        {{
                          studentFilter({
                            student_id: list.student_id,
                            studentEnrollments: studentEnrollments
                          }).promotion
                        }}
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          @click="removeStudent(list)"
                          ><i class="fa fa-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </panel>
          </div>
        </fieldset>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce, orderBy } from 'lodash'

export default {
  name: 'studentListEnrollment',
  props: ['value'],
  data () {
    return {
      model: {},
      student_search_value: '',
      student_search: false,
      studentResources: [],
      studentEnrollments: []
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    studentLists: function () {
      return this.studentResources.filter(
        s =>
          !_.includes(
            this.model.student_id_list.map(stud => stud.student_id),
            s.student_id
          )
      )
    },
    ...mapGetters('studentEnrollment', ['studentFilter'])
  },
  methods: {
    ...mapActions('studentEnrollment', ['getStudent']),
    fetStudentList (params) {
      this.student_search = true
      this.getStudent(params)
        .then(response => {
          let data = []
          response.data.forEach(el => {
            let { level, sub_program, study_time, ...resource } = el
            data.push({ ...level, ...sub_program, ...study_time, ...resource })
          })

          this.studentResources = orderBy(
            data,
            ['level_name_foreign', 'acps_name_foreign', 'card_number'],
            ['desc']
          )
        })
        .finally(() => {
          this.student_search = false
        })
    },
    selectStudent (student) {
      this.model.student_id_list.push({
        student_id: student.student_id,
        is_main_class: true,
        swap_type_id: 0
      })
      this.studentEnrollments.push(student)
    },
    removeStudent (student) {
      this.model.student_id_list.splice(
        this.model.student_id_list.indexOf(student),
        1
      )
      this.studentEnrollments.splice(
        this.studentEnrollments.indexOf(
          this.studentEnrollments.find(s => s.student_id == student.student_id)
        ),
        1
      )
    }
  },
  watch: {
    'model.class_id': function () {
      this.studentResources = []
      this.studentEnrollments = []
      this.student_search_value = ''
    },
    student_search_value: debounce(function (value) {
      if (value) {
        this.fetStudentList({
          search: value,
          page: -1,
          filter: {
            not_in_enrollmented_class: this.model.class_id
          }
        })
      } else {
        this.fetStudentList({
          perPage: 20,
          filter: {
            not_in_enrollmented_class: this.model.class_id
            
          }
        })
      }
    }, 1500)
  }
}
</script>

<style lang="css" scoped>
#enroll {
  height: 70vh;
}

#student-table-container {
  height: 40vh;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

#student-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

#student-table > tbody > tr > td {
  cursor: pointer;
}

.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
.none-border {
  border: none;
}
</style>
